<template>
     <div class="drawer-body">
        <div>
            <div class="row align-items-center mb-10">
                <div class="col-auto">
                    <h4 class="drawer-title mt-10">Edit consignee</h4>
                </div>
                <div class="col">
                <div class="f-right">
                    <Button type="text" size="small"
                    @click="$emit('closeEditConsigneeSlider')">Cancel</Button>
                    <Button type="primary" size="small" @click="constructConsigneePayload()">save</Button>
                </div>
                </div>
            </div>
            <Form :inline="true" class="form-default form-multi">
                <FormItem label="consignee Name" disabled>
                <Input placeholder="Enter Name" type="text" v-model="consigneeLocal.name"/>
                </FormItem>
                <FormItem label="Reference ID" disabled>
                <Input type="text" v-model="consigneeLocal.reference_id"/>
                </FormItem>
                <div class="mt-20">
                <FormItem label="Address" class="full-width">
                <Input placeholder="Enter Address" type="text" v-model="consigneeLocal.address"/>
                </FormItem>
                <FormItem label="city" required>
                <Input placeholder="Enter city" type="text" v-model="consigneeLocal.city"/>
                </FormItem>
                <FormItem label="state" required>
                <Input placeholder="Enter state" type="text" v-model="consigneeLocal.state"/>
                </FormItem>
                <FormItem label="region" required>
                <Input placeholder="Enter region" type="text" v-model="consigneeLocal.region"/>
                </FormItem>
                <FormItem label="pincode" required>
                <Input placeholder="Enter pincode" type="text" v-model="consigneeLocal.pincode"/>
                </FormItem>
                </div>
            </Form>
            </div>
        </div>
</template>
<script>
import { mandatoryConsigneeFields } from '@/modules-v2/indent/constants/order';
import { deepCopy } from '@firebase/util';

export default {
  data() {
    return {
      consigneeLocal: null,
    };
  },
  props: {
    data: {
      default: () => ({}),
      type: Object,
    },
  },
  created() {
    this.consigneeLocal = JSON.parse(JSON.stringify(this.data)); // deep copy
  },
  methods: {
    constructConsigneePayload() {
      let payload = {};
      // fields which are not allowed in updated consignee
      const keysNotRequired = ['id', 'optima_category', 'created_at', 'coordinates', 'updated_at', 'updated_user'];
      Object.keys(this.consigneeLocal).forEach((key) => {
        if (key === 'customer_logistic_leader' && this.consigneeLocal[key]
        && this.consigneeLocal[key].id) {
          payload.customer_logistic_leader = this.consigneeLocal.customer_logistic_leader.id;
        } else if (key === 'exclude_vehicles') {
          payload.exclude_vehicles_list = this.consigneeLocal[key];
        } else if (!keysNotRequired.includes(key)) {
          payload[key] = this.consigneeLocal[key];
        }
      });
      if (payload.dispatch_schedule) {
        const dispatchSchedule = deepCopy(payload.dispatch_schedule);
        delete payload.dispatch_schedule;
        payload = {
          ...payload,
          ...dispatchSchedule,
        };
      }
      const consigneeEntries = Object.entries(payload);
      const formCheck = consigneeEntries && consigneeEntries.length && Object.entries(
        payload).filter(
        field => mandatoryConsigneeFields.includes(field[0])).every(detail => detail[1]);
      if (formCheck) {
        this.$emit('updateConsignee', payload, this.consigneeLocal.id);
      } else {
        this.$errorMessage({ message: 'Please enter all the mandatory details' });
      }
    },
  },
};
</script>
